/*
 * Copyright (c) Nexign, JSC, 2019-2020.
 */
/**
 * Styled components for DropDownFilter
 *
 * @author Vladislav Oshkanov
 * @author Yakov Gushchin
 * @author Evgenij Tyan
 * @author Maxim Fedorov
 * @author Anton Panasenko
 * @version 1.3.1
 * @since 1.0.0
 */

import styled from 'styled-components';

import { colors } from '../../../../theme';
import { FlexStyled } from '../../Block/Flexbox';
import { DropDownButtonAreaTypeEnum, DropDownFilterButtonSize, IStyledProps } from '../DropDownFilter';

interface IButtonAreaStyled {
    renderType?: DropDownButtonAreaTypeEnum;
}

const ButtonAreaStyled = styled(FlexStyled).attrs({
    className: 'drop-down-filter__button-area',
})<IButtonAreaStyled>`
    position: relative;
    justify-content: space-between;
    align-content: center;
    height: 32px;
    ${props => props.renderType === DropDownButtonAreaTypeEnum.monthPicker ? 'margin: 24px 0 8px'
    : 'margin-top: 16px'};
    & .drop-down-filter__ok-button button {
      min-height: 32px;
      min-width: 87px;
    }
`;

const ButtonAreaLeftStyled = styled.div.attrs({
    className: 'drop-down-filter__button-area-left',
})`
    display: flex;
    height: inherit;
    & .drop-down-filter__cancel-button {
        justify-content: space-between;
        align-items: center;
        display: flex;
        margin-left: 16px;

        .text-block {
             line-height: 15px;
        }
    }
`;

const FilterContainerStyled = styled.div`
    display: flex;
    position: relative;
`;

interface IFilterButtonStyledProps extends IStyledProps{
    filterButtonSize?: DropDownFilterButtonSize;
}

const FilterButtonStyled = styled.div<IFilterButtonStyledProps>`
    position: relative;
    justify-content: space-around;
    align-items: center;
    display: inline-flex;
    width: 100%;
    min-width: 64px;
    height: ${props => props.filterButtonSize === DropDownFilterButtonSize.medium ? 48 : 32}px;
`;

const ToolTipStyled = styled.div`
    position: fixed;
    z-index: 10;
    display: block;
    padding: 16px;
    border-radius: 2px;
    box-shadow: 0 2px 12px 0 rgba(51, 51, 51, 0.2);
    background-color: ${colors.dropDownFilterBgColor};
    text-decoration: none;

    & .drop-down-filter__content .range-date-picker__calendar-head-thead .input__input-block {
        border-color: ${colors.dropDownFilterInputBorderColor};
    }
`;

export {
    ButtonAreaStyled,
    ButtonAreaLeftStyled,
    FilterContainerStyled,
    FilterButtonStyled,
    ToolTipStyled,
};
